import { getBetStakeSystemBetProps, getBetDataProps } from "../../bet";
export const getBetSummarySystemBetProps = (bet, state) => {
    return {
        betStake: getBetStakeSystemBetProps(bet, state),
        betData: getBetDataProps(bet, state)
    };
};
//# sourceMappingURL=getBetSummarySystemBetProps.js.map